(() => {
	// Guard to avoid redeclaration when bundling
	if (typeof window !== 'undefined' && window.chartTimeLoggedByDate) {
		return;
	}

	const chartFactory = () => {
		return {
        chart_style: {
            colors: ['#3b82f6', '#a855f7'],
            fill: {
                gradient: {
                    shadeIntensity: .1,
                    opacityFrom: .5,
                    opacityTo: 0,
                    stops: [50, 100, 100, 100]
                }
            },
            xaxis: {
                labels: {
                    style: {
                        colors: '#a3a3a3',
                    }
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: '#a3a3a3'
                    }
                }
            },
            grid: {
                borderColor: '#404040'
            }
        },
        style: {
            colors: ['#2563eb', '#9333ea'],
            fill: {
                gradient: {
                    shadeIntensity: .1,
                    opacityFrom: .5,
                    opacityTo: 0,
                    stops: [50, 100, 100, 100]
                }
            },
            xaxis: {
                labels: {
                    style: {
                        colors: '#9ca3af'
                    }
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: '#9ca3af'
                    }
                }
            },
            grid: {
                borderColor: '#e5e7eb'
            }
        },
        chart: {
            chart: {
                height: 300,
                type: 'area',
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: false
                }
            },
            series: [{
                name: 'Time Logged',
                data: 'data points here'
            },],
            legend: {
                show: false
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 2
            },
            grid: {
                strokeDashArray: 2
            },
            fill: {
                type: 'gradient',
                gradient: {
                    type: 'vertical',
                    shadeIntensity: 1,
                    opacityFrom: 0.1,
                    opacityTo: 0.8
                }
            },
            xaxis: {
                type: 'category',
                tickPlacement: 'on',
                categories: 'dates here',
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                crosshairs: {
                    stroke: {
                        dashArray: 0
                    },
                    dropShadow: {
                        show: false
                    }
                },
                tooltip: {
                    enabled: false
                },
                labels: {
                    style: {
                        colors: '#9ca3af',
                        fontSize: '13px',
                        fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                        fontWeight: 400
                    },
                    formatter: (title) => {
                        let t = title;

                        if (t) {
                            const newT = t.split(' ');
                            t = `${newT[0]} ${newT[1].slice(0, 3)}`;
                        }

                        return t;
                    }
                }
            },
            yaxis: {
                labels: {
                    align: 'left',
                    minWidth: 0,
                    maxWidth: 140,
                    style: {
                        colors: '#9ca3af',
                        fontSize: '13px',
                        fontFamily: 'ui-sans-serif, system-ui, sans-serif',
                        fontWeight: 400
                    },
                    formatter: (value) => value >= 1000 ? `${value / 1000}k` : value
                }
            },
            tooltip: {
                x: {
                    format: 'MMMM yyyy'
                },
                y: {
                    formatter: (value) => {
                        const v = parseFloat(value) || 0;
                        const hrs = Math.floor(v);
                        const mins = Math.round((v - hrs) * 60);
                        return mins ? `${hrs}h ${mins}m` : `${hrs}h`;
                    }
                },
                custom: function (props) {
                    const {
                        categories
                    } = props.ctx.opts.xaxis;
                    const {
                        dataPointIndex
                    } = props;
                    const title = categories[dataPointIndex].split(' ');
                    const newTitle = `${title[0]} ${title[1]}`;
                    const value = props.series[props.seriesIndex][dataPointIndex];
                    const hrs = Math.floor(value);
                    const mins = Math.round((value - hrs) * 60);
                    const formattedTime = mins ? `${hrs}h ${mins}m` : `${hrs}h`;
                    let html = '<div class="flex flex-col bg-white border border-gray-200 p-2 md:p-2 dark:bg-neutral-900 dark:border-neutral-700 dark:shadow-neutral-700/70">'
                    html += `<h4 class="text-lg font-semibold mb-2 text-gray-800 dark:text-white">${newTitle}</h4>`;
                    html += `<p class="text-sm text-gray-600 dark:text-neutral-400">Time Logged: <span class="font-medium text-gray-800 dark:text-white">${formattedTime}</span></p>`;
                    html += '</div>';
                    return html;
                }
            },
            responsive: [{
                breakpoint: 568,
                options: {
                    chart: {
                        height: 300
                    },
                    labels: {
                        style: {
                            colors: '#9ca3af',
                            fontSize: '11px',
                            fontFamily: 'Inter, ui-sans-serif',
                            fontWeight: 400
                        },
                        offsetX: -2,
                        formatter: (title) => title.slice(0, 3)
                    },
                    yaxis: {
                        labels: {
                            align: 'left',
                            minWidth: 0,
                            maxWidth: 140,
                            style: {
                                colors: '#9ca3af',
                                fontSize: '11px',
                                fontFamily: 'Inter, ui-sans-serif',
                                fontWeight: 400
                            },
                            formatter: (value) => value >= 1000 ? `${value / 1000}k` : value
                        }
                    },
                },
            }]
        },
    };
    };

    if (typeof window !== 'undefined') {
        window.chartTimeLoggedByDate = chartFactory;
    } else {
        // Fallback export for non-browser contexts
        globalThis.chartTimeLoggedByDate = chartFactory;
    }
})();